import { render, staticRenderFns } from "./PackageField.vue?vue&type=template&id=1833885a&scoped=true"
import script from "./PackageField.vue?vue&type=script&lang=js"
export * from "./PackageField.vue?vue&type=script&lang=js"
import style0 from "./PackageField.vue?vue&type=style&index=0&id=1833885a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833885a",
  null
  
)

export default component.exports